<template>
  <div class="relative pt-2">
    <div
      class="relative w-full h-9 transition-opacity duration-300"
      :class="{ 'opacity-50': disabled || readonly }"
    >
      <input
        :value="value"
        :disabled="disabled"
        :readonly="readonly"
        :type="type"
        :class="{ 'has-value': !!value }"
        class="
          mt-input
          px-0
          w-full
          h-full
          text-dark text-sm
          font-medium
          leading-4
          bg-transparent
          border-none
          outline-none
          focus:outline-none
          shadow-none
          focus:ring-0
        "
        placeholder=" "
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
        @input="$emit('change', $event.target.value)"
      />
      <label
        class="
          absolute
          -top-0.5
          left-0
          w-full
          h-full
          text-dark text-opacity-50 text-sm
          border-b border-dark border-opacity-60
          pointer-events-none
        "
      >
        <span
          class="absolute left-0 top-1/4 text-sm transition-all duration-300"
          >{{ label }}</span
        >
      </label>
    </div>
    <span
      v-if="showChangeButton"
      class="absolute bottom-2.5 right-0 hover:underline cursor-pointer"
      @click="$emit('edit-value')"
      >{{ $t('common.change') }}</span
    >
  </div>
</template>

<script lang="ts">
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { LocaleMessages } from 'vue-i18n';

@Component
export default class TextField extends Vue {
  @Model('change', { type: String }) value!: string;
  @Prop({ type: [String, Object], required: true }) label!:
    | string
    | LocaleMessages;
  @Prop({ type: String, default: 'text' }) type!: string;
  @Prop({ type: Boolean, default: false }) disabled!: string;
  @Prop({ type: Boolean, default: false }) readonly!: string;
  @Prop({ type: Boolean, default: false }) showChangeButton!: string;
}
</script>
